// @catalog F.010
/**
 * Exporta filas de la tabla /compras/forecast (vista filtrada o selección) a
 * CSV — UTF-8 con BOM vía downloadCsv, así Excel lo abre con encoding y
 * columnas correctos.
 *
 * Columnas espejan ForecastTable (Producto … Conf.) más identificadores
 * útiles fuera de la app (SKU, categoría, ERP). Mismo formato que el export
 * del diálogo "Productos seleccionados" (export-csv.ts).
 */
import type { ProductData } from "./types";
import { getDisplayText } from "./text-utils";
import { csvEscape, defaultCsvFilename, downloadCsv } from "./export-csv";
import { demandLabel } from "../../components/Forecast/forecast-row-cells";

const HEADERS = [
  "SKU",
  "Producto",
  "Categoria",
  "ERP",
  "Inventario",
  "Punto reorden",
  "Ventas 4m MXN",
  "DCI tiendas",
  "DCI objetivo",
  "ABC-XYZ",
  "Demanda",
  "Metodo",
  "Pronostico/mes",
  "Confianza %",
  "Activo compra",
];

function erpLabel(p: ProductData): string {
  if (p.existsInOdoo16 && p.existsInOdoo18) return "16/18";
  if (p.existsInOdoo18) return "18";
  if (p.existsInOdoo16) return "16";
  return "";
}

export function buildForecastTableCsv(products: ProductData[]): string {
  const rows: string[] = [HEADERS.map(csvEscape).join(",")];

  for (const p of products) {
    const demand = demandLabel(p.demandClassification).label;
    rows.push(
      [
        csvEscape(p.unifiedCode ?? ""),
        csvEscape(getDisplayText(p.unifiedName)),
        csvEscape(p.unifiedCategory ?? ""),
        csvEscape(erpLabel(p)),
        csvEscape(p.totalAvailableQty ?? ""),
        csvEscape(p.reorderPoint ?? ""),
        csvEscape(p.recentSalesAmount ?? ""),
        csvEscape(p.dciStoreCount ?? ""),
        csvEscape(p.dciTargetStores ?? ""),
        csvEscape(p.abcXyzSegment ?? ""),
        csvEscape(demand === "—" ? "" : demand),
        csvEscape(p.matchingMethod ?? ""),
        csvEscape(p.forecastNextPeriod ?? ""),
        csvEscape(Math.round((p.matchingConfidence ?? 0) * 100)),
        csvEscape(p.activeForPurchase === false ? "No" : "Si"),
      ].join(","),
    );
  }

  rows.push("");
  rows.push(`# Productos,${products.length}`);
  rows.push(`# Generado,${new Date().toISOString()}`);

  return rows.join("\r\n");
}

export function exportForecastTable(
  products: ProductData[],
  scope: "filtrados" | "seleccionados",
): void {
  downloadCsv(
    defaultCsvFilename(`forecast_${scope}`),
    buildForecastTableCsv(products),
  );
}
